export type ParsedErrorCode = {
    domain: number;
    endpoint: number;
    category: "success" | "permission" | "invalid_data" | "header" | "path" | "elaboration" | "server" | "unknown";
    raw: string;
};

const categoryMap: Record<string, ParsedErrorCode["category"]> = {
    "0": "success",
    "1": "permission",
    "2": "invalid_data",
    "3": "header",
    "5": "path",
    "6": "elaboration",
    "9": "server",
};

export const parseErrorCode = (errorCode: string): ParsedErrorCode => {
    const parts = (errorCode ?? "").split(".");
    const domain = parseInt(parts[0] ?? "0");
    const endpoint = parseInt(parts[1] ?? "0");
    const categoryPart = parts[2] ?? "";

    return {
        domain: Number.isNaN(domain) ? 0 : domain,
        endpoint: Number.isNaN(endpoint) ? 0 : endpoint,
        category: categoryMap[categoryPart[0] ?? ""] ?? "unknown",
        raw: errorCode,
    };
};

export const getErrorCodeMessage = (errorCode: string): string => {
    const parsed = parseErrorCode(errorCode);

    switch (parsed.category) {
        case "success":
            return "Operation completed successfully.";
        case "permission":
            return "You do not have permission for this operation.";
        case "invalid_data":
            return "Some required data is missing or invalid.";
        case "header":
            return "Request headers are invalid or incomplete.";
        case "path":
            return "The requested route is invalid.";
        case "elaboration":
            return "The server could not complete the operation.";
        case "server":
            return "A server error occurred. Please try again later.";
        default:
            return "Unexpected response code.";
    }
};
